import { render } from "./DirectMailCheckout.vue?vue&type=template&id=78e82966&scoped=true"
import script from "./DirectMailCheckout.vue?vue&type=script&lang=js"
export * from "./DirectMailCheckout.vue?vue&type=script&lang=js"

import "./DirectMailCheckout.vue?vue&type=style&index=0&id=78e82966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e82966"]])

export default __exports__